const OVERFLOW_LEFT_ATTRIBUTE = 'data-overflow-left';
const OVERFLOW_RIGHT_ATTRIBUTE = 'data-overflow-right';
const OVERFLOW_READY_ATTRIBUTE = 'data-overflow-ready';

/**
 * Переключает на контейнере атрибуты data-overflow-left / data-overflow-right:
 * атрибут стоит, когда соответствующий край не пересекается с видимой областью
 * контейнера — то есть за этим краем есть скрытый контент.
 */
export function toggleOverflowAttributes(
  container: HTMLElement,
  entries: IntersectionObserverEntry[],
  leftEdge: Element,
): void {
  for (const entry of entries) {
    const attribute = entry.target === leftEdge ? OVERFLOW_LEFT_ATTRIBUTE : OVERFLOW_RIGHT_ATTRIBUTE;

    container.toggleAttribute(attribute, !entry.isIntersecting);
  }
}

/**
 * Взводит на контейнере data-overflow-ready через два кадра: атрибут включает
 * CSS transition краёв только после первой отрисовки их состояния, чтобы первое
 * появление fade было мгновенным, а не анимированным. Два кадра, потому что
 * rAF-колбэк выполняется до пересчёта стилей того же кадра — одинарный rAF
 * включил бы transition одновременно с первым изменением.
 * Возвращает функцию отмены.
 */
export function scheduleReadyAttribute(container: HTMLElement): () => void {
  let frameId = requestAnimationFrame(() => {
    frameId = requestAnimationFrame(() => {
      container.setAttribute(OVERFLOW_READY_ATTRIBUTE, '');
    });
  });

  return () => cancelAnimationFrame(frameId);
}
